import { render, staticRenderFns } from "./TransportOrderMultiAdd.vue?vue&type=template&id=187c1a8c"
import script from "./TransportOrderMultiAdd.vue?vue&type=script&lang=js"
export * from "./TransportOrderMultiAdd.vue?vue&type=script&lang=js"
import style0 from "./TransportOrderMultiAdd.vue?vue&type=style&index=0&id=187c1a8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports